import React from 'react';

function DirectorRequestSummaryCards({ summary }) {
  return (
    <div className="role-request-summary-row">
      <div className="role-request-summary-card" title="Awaiting a decision — no policy concerns flagged.">
        <span>Pending</span>
        <strong>{summary.pending}</strong>
        <em>Awaiting decision</em>
      </div>
      <div className="role-request-summary-card role-request-summary-card-warning" title="A coverage or policy rule was triggered. These need a closer look before approving.">
        <span>Review Needed</span>
        <strong>{summary.reviewNeeded}</strong>
        <em>Policy concern flagged</em>
      </div>
      <div className="role-request-summary-card">
        <span>Approved</span>
        <strong>{summary.approved}</strong>
      </div>
      <div className="role-request-summary-card">
        <span>Denied</span>
        <strong>{summary.denied}</strong>
      </div>
    </div>
  );
}

export default DirectorRequestSummaryCards;
